import { FccOpenTransactionEntityConfig } from '@app/modules/fcc/fcc-open-transaction/presets/fcc-open-transaction-entity-config.model';
import {
	Tss,
	TssModeEnum,
	TssModeSubTypeEnum
}                                         from '@app/modules/tss/models/tss.model';
import { EntityActionEventEnum }          from '@models/entity.model';

// ENUMS #############################################################
// API enums *********************************************************


// UI enums *********************************************************
export enum FccOpenTransactionPresetEnum {
	TASK_CENTER_FCC_OPEN_TRANSACTIONS = 'taskCenterFccOpenTransactions'
}

export enum FccOpenTransactionActionEntityIdentifierEnum {
	FCC_OPEN_TRANSACTION = 'fccOpenTransaction',
	TSS = 'tss'
}

// TYPES #############################################################
export type FccOpenTransactionProps = ( keyof FccOpenTransactionCounter )[];

// INTERFACES ########################################################
// API interfaces ****************************************************
// UI interfaces *****************************************************
export interface IFccOpenTransactionEntityActionEvent {
	action: EntityActionEventEnum;

	actionForEntity: FccOpenTransactionActionEntityIdentifierEnum;

	fccOpenTransaction: FccOpenTransaction;

	fccOpenTransactionEntityConfig?: FccOpenTransactionEntityConfig;
}

// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TMO - TransitionalModelObject)
export class FccOpenTransactionsInfoCountItemTMO {
	public count?: number = undefined;
	public lowerBoundary?: number = undefined;
	public tssMode?: TssModeEnum = undefined;
	public tssModeSubtype?: TssModeSubTypeEnum = undefined;
	public upperBoundary?: number = undefined;
}

export class FccOpenTransactionsInfoCountsTMO {
	public counts?: FccOpenTransactionsInfoCountItem[] = undefined;
}

export class FccOpenTransactionInfoCounterTMO {
	public fccId?: string = undefined;

	public tssId?: string = undefined;

	public dateTime?: Date = undefined;

	public openTransactionsCount?: number = undefined;
}


// APP MODEL (EMO - EntityModelObject)
export class FccOpenTransactionsInfoCountItem extends FccOpenTransactionsInfoCountItemTMO {}

export class FccOpenTransactionsInfoCounts extends FccOpenTransactionsInfoCountsTMO {}

export class FccOpenTransactionCounter extends FccOpenTransactionInfoCounterTMO {}

export class FccOpenTransaction {
	public tss: Tss = undefined;
	public fccOpenTransactionCounter: FccOpenTransactionCounter = undefined;
}

